import React from 'react';
import dayjs from 'dayjs';
import Text from '../../text/Text';

const PopulateHeaders = ({ displayDate }) => {
  const dayHeaders = [];

  for (let i = 0; i <= 6; ++i) {
    const day = dayjs(displayDate).day(i).format('dddd').substr(0, 2);
    dayHeaders.push(
      <div key={`headers-${i}`} className="d-flex justify-content-center">
        <Text className="opacity-50 text-center p-4">{day}</Text>
      </div>,
    );
  }
  return dayHeaders;
};

export default PopulateHeaders;
